import { BarChart3, Bell, Building2, CalendarRange, CheckSquare, CreditCard, Database, FileText, Gamepad2, Layers, LayoutDashboard, LayoutGrid, LayoutTemplate, Mail, Megaphone, MessageSquare, Newspaper, Palette, ScanSearch, Shield, ShieldCheck, Smartphone, Star, Users, Wallet, Waypoints, } from "lucide-react";
export const G1_APPS = [
    // Cross-domain admin surfaces — the two shell zones.
    {
        id: "console",
        name: "Console",
        url: "https://console.g1.network",
        Icon: LayoutDashboard,
        zone: "console",
        purpose: "Per-site environment — content, ranking, AB tests, global entities, games catalog.",
    },
    {
        id: "admin",
        name: "Admin",
        url: "https://admin.g1.network",
        Icon: Shield,
        zone: "admin",
        purpose: "Operator zone — staff, integrations (CIO/GitHub/Cloudflare), AI models, network catalog, platform settings.",
    },
    // Per-domain operator SPAs (Phase 4 of taxonomy reorg)
    { id: "review", name: "Review", url: "https://review.g1.network", Icon: Star },
    { id: "news", name: "News", url: "https://news.g1.network", Icon: Newspaper },
    {
        id: "subscription",
        name: "Subscriptions",
        url: "https://subscription.g1.network",
        Icon: CreditCard,
    },
    { id: "email", name: "Email", url: "https://email.g1.network", Icon: Mail },
    { id: "template", name: "Templates", url: "https://template.g1.network", Icon: FileText },
    { id: "landing", name: "Landing", url: "https://landing.g1.network", Icon: LayoutTemplate },
    { id: "creative", name: "Creative", url: "https://creative.g1.network", Icon: Palette },
    { id: "affiliates", name: "Affiliates", url: "https://affiliates.g1.network", Icon: Users },
    {
        id: "markets",
        name: "Markets",
        url: "https://app.g1.markets",
        Icon: Building2,
        purpose: "A2A marketplace — brand/affiliate negotiation + legacy network CRM.",
    },
    { id: "crm", name: "CRM", url: "https://crm.g1.network", Icon: Database },
    { id: "tasks", name: "Tasks", url: "https://tasks.g1.network", Icon: CheckSquare },
    { id: "analytics", name: "Analytics", url: "https://analytics.g1.network", Icon: BarChart3 },
    { id: "flow", name: "Traffic Flow", url: "https://flow.g1.network", Icon: Waypoints },
    { id: "pwa", name: "PWA", url: "https://pwa.g1.network", Icon: Smartphone },
    { id: "push", name: "Push", url: "https://push.g1.network", Icon: Bell },
    { id: "sms", name: "SMS", url: "https://sms.g1.network", Icon: MessageSquare },
    { id: "mediaplan", name: "Media Plan", url: "https://mediaplan.g1.network", Icon: CalendarRange },
    { id: "minisites", name: "Minisites", url: "https://minisites.g1.network", Icon: Layers },
    { id: "apps", name: "Apps", url: "https://apps.g1.network", Icon: LayoutGrid },
    {
        id: "emailnetwork",
        name: "Email Network",
        url: "https://emailnetwork.g1.network",
        Icon: ScanSearch,
    },
    {
        id: "cryptonetwork",
        name: "Crypto Network",
        url: "https://cryptonetwork.g1.network",
        Icon: Wallet,
    },
    // Adtech operator SPAs (Phase 5+ of programmatic build — operator deep-link entries
    // для support/admin workflows; external partner sign-in happens at /app sub-path).
    { id: "ssp", name: "SSP", url: "https://ssp.g1.network", Icon: Building2 },
    { id: "dsp", name: "DSP", url: "https://dsp.g1.network", Icon: Megaphone },
    { id: "ads", name: "Ads", url: "https://ads.g1.network", Icon: LayoutDashboard },
    { id: "cmp", name: "CMP", url: "https://cmp.g1.network", Icon: ShieldCheck },
    // Specialty
    { id: "scr", name: "Brandkit", url: "https://scr.g1.network", Icon: ScanSearch },
    { id: "games", name: "Games", url: "https://g1.games", Icon: Gamepad2 },
    { id: "agent", name: "Chat", url: "https://chat.g1.network", Icon: MessageSquare },
];
function findZone(zone) {
    const app = G1_APPS.find((a) => a.zone === zone);
    if (!app)
        throw new Error(`G1_APPS missing zone "${zone}" — packages/ui/src/apps.ts out of sync`);
    return app;
}
/**
 * Lookup map for the two shell zones. Use this from dashboards and other
 * places that need the zone's `purpose` string, hostname, or icon.
 *
 * Example:
 *   import { G1_ZONE_META } from "@theg1group/ui";
 *   const meta = G1_ZONE_META.admin;  // { app, purpose, host, zone }
 */
export const G1_ZONE_META = {
    console: (() => {
        const app = findZone("console");
        return { zone: "console", app, host: new URL(app.url).host, purpose: app.purpose ?? "" };
    })(),
    admin: (() => {
        const app = findZone("admin");
        return { zone: "admin", app, host: new URL(app.url).host, purpose: app.purpose ?? "" };
    })(),
};
//# sourceMappingURL=apps.js.map